import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface SafeAreaData {
    top: number;
    bottom: number;
}

@Injectable({
    providedIn: 'root'
})
export class SafeAreaService implements OnDestroy {
    private safeAreaDataSubject = new BehaviorSubject<SafeAreaData>({ top: 0, bottom: 0 });
    public safeAreaData$: Observable<SafeAreaData> = this.safeAreaDataSubject.asObservable();

    private safeAreaCallback: ((data: SafeAreaData) => void) | null = null;

    constructor() {
        this.initializeSafeAreaListener();
    }

    private initializeSafeAreaListener(): void {
        // Create the global function that Flutter will call
        this.safeAreaCallback = (data: SafeAreaData) => {
            console.log('Safe area data received from Flutter:', data);
            this.safeAreaDataSubject.next(data);
        };

        // Set the global function
        (window as any).safeArea = this.safeAreaCallback;

        // Request safe area data from Flutter if not received within 2 seconds
        setTimeout(() => {
            const currentData = this.safeAreaDataSubject.value;
            if (currentData.top === 0 && currentData.bottom === 0) {
                console.log('Requesting safe area data from Flutter...');
                this.requestSafeAreaFromFlutter();
            }
        }, 2000);
    }

    private requestSafeAreaFromFlutter(): void {
        // Try to use the Flutter channel to request safe area data
        if ((window as any).flutter_inappwebview) {
            (window as any).flutter_inappwebview.callHandler('safeArea', 'request');
        } else {
            console.log('Flutter channel not available, safe area data will be sent automatically');
        }
    }

    // Getter for current safe area data
    get currentSafeAreaData(): SafeAreaData {
        return this.safeAreaDataSubject.value;
    }

    // Getter for top padding
    get topPadding(): number {
        return this.safeAreaDataSubject.value.top;
    }

    // Getter for bottom padding
    get bottomPadding(): number {
        return this.safeAreaDataSubject.value.bottom;
    }

    ngOnDestroy(): void {
        // Clean up the global function
        if (this.safeAreaCallback) {
            delete (window as any).safeArea;
            this.safeAreaCallback = null;
        }
    }
}
